var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDistanceMappingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31 50C41.4934 50 50 41.4934 50 31C50 20.5066 41.4934 12 31 12C20.5066 12 12 20.5066 12 31C12 41.4934 20.5066 50 31 50ZM31 48C40.3888 48 48 40.3888 48 31C48 21.6112 40.3888 14 31 14C21.6112 14 14 21.6112 14 31C14 40.3888 21.6112 48 31 48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48C40.3888 48 48 40.3888 48 31C48 21.6112 40.3888 14 31 14C21.6112 14 14 21.6112 14 31C14 40.3888 21.6112 48 31 48Z",
    fill: "url(#paint0_radial_22215_24133)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_22215_24133",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5 17.5) rotate(121.264) scale(32.7567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#FFDC22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#E4FF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0FFE19"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistanceMappingActive);
export default __webpack_public_path__ + "static/media/distance-mapping-active.6645436cf08186d19068462ee0997cdd.svg";
export { ForwardRef as ReactComponent };